export const EVENT_HOVER_HALO_BASE_OUTER_RADIUS = 1.06;
export const EVENT_HOVER_HALO_MAX_RADIUS_RATIO = 2.6;

export function getEventHoverHaloScale(nodeRadius: number, phase: number) {
  const radiusRatio = 2.4 + Math.sin(phase * 4.5) * 0.2;
  return (nodeRadius * radiusRatio) / EVENT_HOVER_HALO_BASE_OUTER_RADIUS;
}
